module.exports = __webpack_public_path__ + "img/logo-lg.e6e61ffb.png";